module.exports = __webpack_public_path__ + "img/组 8458@2x.dbe28558.png";